// extracted by mini-css-extract-plugin
export default {"dot":"Reports_dot__ODHqO","active":"Reports_active__LpSJZ"};